module.exports = __webpack_public_path__ + "static/media/shower3.e9d2dd5c.gif";